import { render, staticRenderFns } from "./SelfPublishing.vue?vue&type=template&id=48df8fda&scoped=true&"
import script from "./SelfPublishing.vue?vue&type=script&lang=js&"
export * from "./SelfPublishing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48df8fda",
  null
  
)

export default component.exports